import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import airportApi from "../../../api/airport.api";
import { generateNewAirport } from "../../../context/QuoteContext/actions";
import { QuoteContextStore } from "../../../context/QuoteContext/QuoteContext";
import { debounce } from "../../../services/utils";

const AirportCodeAutocomplete = ({...props}) => {
    const [airports, setAirports] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { getValues, reset } = useFormContext();
    const { loadAirport, airports: contextAirports ,locked_quote} = useContext(QuoteContextStore);
    const defaultAirport = contextAirports[Object.keys(contextAirports)[0]];

    async function filter(value) {
        if(value === ""){
            setAirports([]);
            return;
        } 
        setIsLoading(true);
        const { data } = await airportApi.getAirportByCode(value)
        setAirports([...data]);
        setIsLoading(false);
    }
    
    const debounceHandler = useCallback(debounce(filter, 300), []);

    const handleFiltering = (e, newval) => {
        debounceHandler(newval);
    }

    const handleAirportPick = async (e, value) => {
        if(!value) {
            await loadAirport({
                airport_not_found: getValues()["airport_not_found"],
                ...generateNewAirport()
            });
            return;
        }
        reset({...value})
        await loadAirport(value);
    }

    return (
        <Autocomplete
            disabled={locked_quote}
            fullwidth
            getOptionLabel={(option) => `${option.code} - ${option.name}`}
            loading={isLoading}
            value={defaultAirport.name && defaultAirport.code ? defaultAirport : null}
            className="margin-top-8"
            onChange={handleAirportPick}
            onInputChange={handleFiltering}
            options={airports}
            filterOptions={(x) => x}
            renderInput={(params) => (
                <TextField
                    {...params}
                    fullWidth={true}
                    variant="outlined"
                    className="margin-top-8 margin-bottom-basic"
                    placeholder="Type airport code"
                />
            )}
        />
    );
}

export default AirportCodeAutocomplete;